import { useEffect } from 'react';
import { useState } from 'react';

export const useActiveFuse = (active: boolean) => {
  const [activeFuse, setActiveFuse] = useState(false);

  useEffect(() => {
    if (active) {
      setActiveFuse(true);
    }
  }, [active]);
  return activeFuse;
};
